import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Button from '../../../UI/Button/Button';
import {hideOverlay} from '../../../v2/actions/overlay-actions';
import CheckoutOverlay from '../../../v2/components/CheckoutOverlay/CheckoutOverlay';
import Translation from '../../../v2/lang/Translation';
import DeliveryOptionNonShippableMessage from '../DeliveryOptionNonShippableMessage/DeliveryOptionNonShippableMessage';
import DeliveryOptionProductListContainer
from '../DeliveryOptionProductListContainer/DeliveryOptionProductListContainer';
import BasketItemsProptype from '../../../propTypes/BasketItems.proptype';

export function DeliveryOptionProductPreview(props) {
  const getOverlayTitle = () => {
    if (props.unshippableReason) {
      return 'deliveryOptions.yourItems.unshippable';
    }
    
    if (!props.groupId || !props.deliveryGroupsSize) {
      return 'deliveryOptions.yourItems.default';
    }
    
    return 'deliveryOptions.yourItems';
  };
  return (
    <CheckoutOverlay popup title={getOverlayTitle()} translationPlaceHolders={[props.groupId, props.deliveryGroupsSize]}>
      <div data-test="DeliveryOptionProductPreview">
        <div className="DeliveryOptionProductPreview-content-body">
          <div className="DeliveryOptionProductPreview-content-body-content">
            <DeliveryOptionProductListContainer
              isFastTrackGroup={props.isFastTrackGroup}
              unshippableReason={props.unshippableReason}
              basketItems={props.basketItems}
            />
          </div>
        </div>
  
        {props.unshippableReason && (
          <DeliveryOptionNonShippableMessage
            unshippableReason={props.unshippableReason}
            basketItems={props.basketItems}
            isOverlay
          />
        )}
        
        <div data-test="DeliveryOptionProductPreview-content-footer">
          <Button
            id="DeliveryOptionProductPreview__closeButton"
            primary
            fullWidth
            onClick={props.hideOverlay}
          >
            <Translation>deliveryOptions.returnToCheckout</Translation>
          </Button>
        </div>
      </div>
    </CheckoutOverlay>
  );
}

DeliveryOptionProductPreview.propTypes = {
  hideOverlay: PropTypes.func.isRequired,
  isFastTrackGroup: PropTypes.bool.isRequired,
  unshippableReason: PropTypes.string.isRequired,
  basketItems: PropTypes.arrayOf(PropTypes.shape(BasketItemsProptype)).isRequired,
  groupId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  deliveryGroupsSize: PropTypes.number.isRequired,
};

export default connect(null, {hideOverlay})(DeliveryOptionProductPreview);
